export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14383.0cf22c23.jpg";